import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

// Hook to get active contract years (mirror useAccessibleProjectTypes)
export const useAccessibleContractYears = () => {
  const { data: contractYears = [], isLoading, error } = useQuery({
    queryKey: ['accessible-contract-years'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('contract_years')
        .select('name')
        .eq('is_active', true)
        .order('sort_order');

      if (error) throw error;
      return data?.map(item => item.name) ?? [];
    },
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
    retry: 2,
    placeholderData: []
  });

  return {
    data: contractYears,
    isLoading,
    error
  };
};
